var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#007AB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5599 17.2881V23.8846H21.7354V17.7302C21.7354 16.1849 21.1832 15.1296 19.7985 15.1296C18.7418 15.1296 18.114 15.8401 17.8368 16.528C17.7361 16.7739 17.7102 17.1153 17.7102 17.4601V23.8843H13.8854C13.8854 23.8843 13.9368 13.4608 13.8854 12.3819H17.7104V14.0119C17.7027 14.0247 17.6919 14.0373 17.6851 14.0495H17.7104V14.0119C18.2187 13.2298 19.1251 12.1118 21.1573 12.1118C23.6734 12.1118 25.5599 13.7557 25.5599 17.2881ZM9.88443 6.83728C8.57614 6.83728 7.72021 7.69606 7.72021 8.82437C7.72021 9.92873 8.55133 10.8123 9.83423 10.8123H9.85904C11.193 10.8123 12.0224 9.92873 12.0224 8.82437C11.997 7.69606 11.193 6.83728 9.88443 6.83728ZM7.94753 23.8846H11.7708V12.3819H7.94753V23.8846Z",
    fill: "#F1F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.717d55b242460c5d4d28587d843a4223.svg";
export { ForwardRef as ReactComponent };